import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { selectActivationCode, selectUserCidpId } from "scenes/selectors";
import { APIResponseError } from "types/ApiErrorResponse";
import factory from "utils/getApiHandlerEffect";
import { mfaFlow } from "utils/enum";
import { SagaIterator } from "redux-saga";
import {
  afterReceivingTextMessage,
  afterSubmitPassCode,
  sendTextMessage,
  submitPassCode,
} from "./redux";
import { currentFlow } from "./selectors";

export function* onSendTextMessage(
  action: ReturnType<typeof sendTextMessage>
): SagaIterator<void> {
  const activationCode = yield select(selectActivationCode);
  const cidpId = yield select(selectUserCidpId);
  const currentFlowSetup = yield select(currentFlow);
  const apiHandler: APIHandler = yield call(() => factory());
  try {
    const response = yield call(() =>
      currentFlowSetup !== mfaFlow.MFA
        ? apiHandler.submitPhoneNumber(activationCode, {
            phoneNumber: action.payload || "",
          })
        : apiHandler.putUpdateMFA("phone", cidpId, {
            phoneNumber: action.payload || "",
          })
    );
    if (response?.authenticatorId) {
      yield put(afterReceivingTextMessage("SUCCESS"));
    }
  } catch (err: any) {
    yield put(afterReceivingTextMessage("ERROR"));
  }
}

export function* onSubmitPassCode(
  action: PayloadAction<string>
): SagaIterator<void> {
  const passcode = action.payload;
  const activationCode = yield select(selectActivationCode);
  const cidpId = yield select(selectUserCidpId);
  const currentFlowSetup = yield select(currentFlow);

  const apiHandler: APIHandler = yield call(() => factory());

  try {
    const response = yield call(() =>
      currentFlowSetup === mfaFlow.MFA
        ? apiHandler.updatePassCode("phone", cidpId, passcode)
        : apiHandler.submitPhoneVerificationCode(activationCode, passcode)
    );
    if (response === "success") {
      yield put(afterSubmitPassCode("SUCCESS"));
    }
  } catch (err: any) {
    const error = JSON.parse(err?.body) as APIResponseError;
    if (error.errors[0].message === "Invalid Passcode.") {
      yield put(afterSubmitPassCode("INVALID"));
    } else {
      yield put(afterSubmitPassCode("ERROR"));
    }
  }
}

// watcher function
export default function* phoneAuthenticatorSaga() {
  yield takeLatest(sendTextMessage.type, onSendTextMessage);
  yield takeLatest(submitPassCode.type, onSubmitPassCode);
}
